// import { useEffect } from 'react';
// import { useNavigate } from 'react-router-dom';
import FacebookLoginButton from '../components/FacebookLoginButton';
import GoogleLoginButton from '../components/GoogleLoginButton';
import { authService } from '../services/api';

const BetaLoginPage = () => {
  // const navigate = useNavigate();

  /* 
  // Commented out to allow admins to see this page even when logged in
  useEffect(() => {
    // Check if already logged in
    const token = localStorage.getItem('token');
    if (token) {
      navigate('/');
    }
  }, [navigate]);
  */

  return (
    <div className="min-h-screen bg-gradient-to-br from-blue-50 to-indigo-100 flex items-center justify-center px-4">
      <div className="max-w-md w-full bg-white rounded-2xl shadow-xl p-8">
        <div className="text-center mb-8">
          <h1 className="text-3xl font-bold text-gray-900 mb-2">
            Thai Card Exchange
          </h1>
          <p className="text-gray-600">
            Please sign in to continue
          </p>
        </div>

        <FacebookLoginButton />

        <div className="mt-3">
          <GoogleLoginButton />
        </div>

        <div className="mt-3">
          <button
            onClick={() => authService.loginWithLine()}
            className="w-full flex items-center justify-center px-4 py-2 border border-transparent rounded-lg shadow-sm text-sm font-medium text-white bg-[#00B900] hover:bg-[#009900] focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-[#00B900] transition-colors"
          >
            <svg className="h-5 w-5 mr-2 fill-current" viewBox="0 0 24 24">
              <path d="M20.3 10c0-4.6-4.5-8.3-10-8.3S.3 5.4.3 10c0 4.1 3.6 7.5 8.4 8.2.3.1.8.3.9 1 .1.6 0 1.3-.1 1.6-.1.4-.6 1.6-.6 1.6s-.2.9.5.5c.7-.4 3.9-2.2 5.3-3.8 2.9-1.6 5.6-4.7 5.6-9.1z" />
            </svg>
            Continue with LINE
          </button>
        </div>

        <div className="mt-6 text-center text-sm text-gray-500">
          By continuing, you agree to our{' '}
          <a href="#" className="text-blue-600 hover:underline">Terms of Service</a>
          {' '}and{' '}
          <a href="#" className="text-blue-600 hover:underline">Privacy Policy</a>
        </div>

        <div className="mt-8 pt-6 border-t border-gray-200">
          <p className="text-center text-gray-600 mb-4">Secure authentication with Facebook, Google or LINE</p>
          <div className="grid grid-cols-2 gap-4 text-center">
            <div>
              <div className="text-2xl mb-1">🃏</div>
              <p className="text-sm text-gray-600">Browse Cards</p>
            </div>
            <div>
              <div className="text-2xl mb-1">💰</div>
              <p className="text-sm text-gray-600">Trade & Sell</p>
            </div>
            <div>
              <div className="text-2xl mb-1">📊</div>
              <p className="text-sm text-gray-600">Track Prices</p>
            </div>
            <div>
              <div className="text-2xl mb-1">⭐</div>
              <p className="text-sm text-gray-600">Build Collection</p>
            </div>
          </div>
        </div>

        <div className="mt-6 text-center">
          <a href="/" className="text-blue-600 hover:underline text-sm">
            ← Back to Homepage
          </a>
        </div>

        <div className="mt-4 text-center text-xs text-gray-500">
          Having trouble logging in?{' '}
          <a href="#" className="text-blue-600 hover:underline">Contact Support</a>
        </div>
      </div>
    </div>
  );
};

export default BetaLoginPage;